export const v65 = {
    default: "#C00A26",
    subtle: "#D43140",
    strong: "#A90821",
};
